import { httpUtil } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";

export const subscriptions = {
    updateSubscription,
}

async function updateSubscription(subId, {
    action,
    billing_day,
    scheduled_date,
    use_proposed_date,
    payment_method_id
}) {
    try {
        let body = {
            action: action,
            scheduled_date: scheduled_date,
            use_proposed_date: use_proposed_date,
            payment_method_id: payment_method_id,
            billing_day: billing_day,
        }
        let response = await httpUtil.put({
            resourcePath: '/v1/subscriptions/' + subId,
            body: body,
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception updateSubscription: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
